enum HealthIndicatorEnum {
  UNKNOWN = -1,
  HEALTHY = 1,
  WARNING = 2,
  ERROR = 3,
}

export default HealthIndicatorEnum;
